import React from 'react';
import request from 'arcdynamic-request';
import { setUser } from '../../actions';
import Alert from '../Alert';
import exc from '../../exception';

export default React.createClass({
	getInitialState() {
		return {
			edit: false,
			isBusy: null,
		};
	},
	update(options) {
		this.setState({isBusy: true});

		return request(arc.path.store, {
			service: 'cart',
			action: 'store.Customer.update',
			params: [options],
		}).then(res => {
			if (!this.isMounted()) return;

			this.setState({isBusy: null});

			if (res && res.success) {
				this.setState({
					edit: null,
					message: null,
				});
				setUser(res.data);
			} else {
				this.setState({
					message: res.message,
				});
			}
		}).catch(exc);
	},
	handleName(e) {
		e.preventDefault();

		const firstName = this.refs.firstName.value;
		const lastName = this.refs.lastName.value;

		if (firstName === this.props.user.person.firstName && lastName === this.props.user.person.lastName) {
			this.setState({
				edit: false,
			});
			return;
		}

		this.update({
			value: {
				person: {
					value: {
						firstName,
						lastName,
					}
				}
			}
		});
	},
	handleEmail(e) {
		e.preventDefault();

		const email = this.refs.email.value;
		const username = this.refs.email.value;

		if (email === this.props.user.email) {
			this.setState({
				edit: false,
			});
			return;
		}

		this.update({
			value: {
				email,
				username,
			}
		});
	},
	handlePassword(e) {
		e.preventDefault();

		const password = this.refs.password.value;
		const confirmPassword = this.refs.confirmPassword.value;

		if (!password && !confirmPassword) {
			this.setState({
				edit: false,
			});
			return;
		}

		if (password !== confirmPassword) {
			this.setState({
				message: 'Passwords do not match',
			});
			return;
		}

		this.update({
			value: {
				password,
			}
		});
	},
	render() {
		const user = this.props.user;

		const sections = [
			{
				name: 'Name',
				onSubmit: this.handleName,
				key: 'name',
				display: (
					<div>{user.person.firstName} {user.person.lastName}</div>
				),
				edit: (
					<div>
						<input ref='firstName' autoFocus required type='text' defaultValue={user.person.firstName} placeholder='First Name' autoComplete='given-name'/> 
						<input ref='lastName' required type='text' defaultValue={user.person.lastName} placeholder='Last Name' autoComplete='family-name'/>
					</div>
				),
			},
			{
				name: 'Email',
				onSubmit: this.handleEmail,
				key: 'email',
				display: (
					<div>{user.email || 'No email provided'}</div>
				),
				edit: (
					<div className='UserInfo_detail_email'>
						<input ref='email' autoFocus type='email' defaultValue={user.email} placeholder='Email' autoComplete='email'/>
					</div>
				),
			},
			{
				name: 'Password',
				onSubmit: this.handlePassword,
				key: 'password',
				display: (
					<div>*****</div>
				),
				edit: (
					<div>
						<input ref='password' autoFocus type='password' defaultValue='' placeholder='New password' autoComplete='new-password'/> 
						<input ref='confirmPassword' type='password' defaultValue='' placeholder='Re-enter password' autoComplete='new-password'/>
					</div>
				),
			},
		];


		return (
			<div className='UserInfo'>
				{
					sections.map(el => (
						<form key={el.key} onSubmit={el.onSubmit} className='UserInfo_item'>
							<div className='UserInfo_head'>{el.name}</div>
							<div className='UserInfo_body'>
								<div className='UserInfo_detail'>
									{
										this.state.edit === el.key ? el.edit : el.display
									}
									{
										this.state.edit === el.key && this.state.message ? <Alert type='error'>{this.state.message}</Alert> : null
									}
								</div>
								{
									this.state.edit === el.key ? (
										<button key={1} type='submit' className='submit-button' data-is-busy={this.state.isBusy}>Save</button>
									) : (
										<button key={2} type='button' onClick={()=> this.setState({edit: el.key, message: null})}>Edit</button>
									)
								}
							</div>
						</form>
					))
				}
			</div>
		);
	},
});
